// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__qg9EE","container":"styles_container__zMt2P","checkmark":"styles_checkmark__ynzW6"};